module.exports = __webpack_public_path__ + "static/media/logo.da403319.svg";